export const MediaObjectConstants = {
  WorkOrder: {
    objectName: "GT4801A",
  },
  Question: {
    objectName: "GT3701A",
  },
  QuestionResponse: {
    objectName: "GTQ353703A",
  },
  maximumSize: {
    width: 1024,
    height: 1024,
  },
  jpegQuality: 0.5,
} as const;
